import type { Wallet } from "@solana/wallet-adapter-react";

enum WalletType {
  PublicKey = "PublicKey",
}

export const StepWalletType = {
  ...WalletType,
};

export type StepWalletType = WalletType;

export const isPublicKeyWalletAdapter = (provider: Wallet | null): boolean => {
  return provider?.adapter.name === "PublicKey";
};
